import { render, staticRenderFns } from "./getPhone.vue?vue&type=template&id=1a5f0a09&"
import script from "./getPhone.vue?vue&type=script&lang=js&"
export * from "./getPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports